var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-title" }, [
          _c("span", { style: { color: _vm.fontColor } }, [
            _vm._v(" 自傳 "),
            _c("span", { staticClass: "en-text" }, [_vm._v("Autobiography")]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "field-value" },
          [
            _c("el-input", {
              staticClass: "w-100",
              attrs: {
                type: "textarea",
                rows: 30,
                maxlength: "10000",
                "show-word-limit": "",
                placeholder: "請輸入内容",
              },
              model: {
                value: _vm.autobiography,
                callback: function ($$v) {
                  _vm.autobiography = $$v
                },
                expression: "autobiography",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "edit-btn-wrap" }, [
        _c(
          "button",
          {
            staticClass: "put-btn",
            attrs: { type: "button" },
            on: { click: _vm.saveAutobiography },
          },
          [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }